import { render } from "./RequestedOrders.vue?vue&type=template&id=5700c106&scoped=true"
import script from "./RequestedOrders.vue?vue&type=script&lang=js"
export * from "./RequestedOrders.vue?vue&type=script&lang=js"

import "./RequestedOrders.vue?vue&type=style&index=0&id=5700c106&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5700c106"]])

export default __exports__